import { ReactNode } from 'react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { SettingItem } from './setting-item';

type Props = {
  children: ReactNode;
  title: string;
};

export const Setting = ({ children, title }: Props) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        borderBottom: `1px solid ${theme.colors.neutral20}`,
        paddingBottom: theme.spacing(2),

        '&:last-child': {
          borderBottom: 0,
        },
      }}
    >
      <Text weight='bold'>{title}</Text>
      {children}
    </div>
  );
};

Setting.Item = SettingItem;
